// IDI-545 (Adrian 10-21): option display = title "<sub-area heading> — <alias>"
// (heading alone without an alias; alias alone without a heading), then the
// product on its own line, then the note. With no alias and no product the
// product line reads "Option". Accepts a view option ({heading, alias, product,
// name, notes}) or a raw line ({subAreaLabel, alias, productLabel, note}).
// Exported for tests and the signing page so every surface reads the same.
// optionProduct resolves a raw line's product with the SAME fallback order as
// the PDF (cmd/quotes pdfOptionAliasProduct): item_name, productLabel,
// product_label, name, description. Review & Send (buildViewQuote) and the
// signing page both call this so all three surfaces show the same product.
export function optionProduct(li) {
  if (!li) return '';
  for (const k of ['item_name', 'itemName', 'productLabel', 'product_label', 'name', 'description']) {
    const v = typeof li[k] === 'string' ? li[k].trim() : '';
    if (v) return v;
  }
  return '';
}

export function optionDisplayParts(o) {
  const heading = (o && (o.heading || o.subAreaLabel || o.sub_area_label)) || '';
  // A blank / whitespace-only alias counts as unset (matches buildViewQuote).
  const alias = o && typeof o.alias === 'string' ? o.alias.trim() : '';
  // A view option (buildViewQuote) carries `product` already resolved; a raw
  // line is resolved with the PDF's fallback order (optionProduct).
  const isView = !!o && typeof o.product === 'string';
  let product = isView ? (o.product || '') : optionProduct(o);
  // Legacy view shape (name only, no alias/product split): name is the product.
  // 'Option' is buildViewQuote's derived placeholder for an unnamed option, so
  // it is not taken as a product name here (it falls through to the same
  // 'Option' fallback below anyway).
  if (isView && !alias && !product && o.name && o.name !== 'Option') product = o.name;
  if (!alias && !product) product = 'Option';
  const title = heading && alias ? `${heading} — ${alias}` : (heading || alias);
  const note = (o && (o.notes || o.note)) || '';
  return { heading, alias, title, product, note, label: alias || product };
}

export default optionDisplayParts;
